import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type CountdownCtaProps = CtaShellProps

export function CountdownCta(props: CountdownCtaProps) {
  return <CtaShell {...props} layout={props.layout ?? "centered"} countdown={props.countdown ?? { target: new Date(Date.now() + 1000 * 60 * 60 * 36).toISOString(), label: "Early access closes" }} />
}
